export default __webpack_public_path__ + "static/normalized_techcrunch-651bbcdba9af88ada8cc0884cbd8e9cd.svg";